export class TownModel {
    constructor(
      public Id: number,
      public TownId: number,
      public TownName: string,
      public StateId: number,
      public CountyName: string,
      public IsOfficial: boolean,
      public CountyId: number) {}
  }